import {
	CURRENT_QUARTER_VS_LAST_YEAR,
	MOBILE_MONTH_VS_LAST_YEAR,
	MOBILE_QUARTER_VS_LAST_YEAR,
	MONTH_DATE_VS_LAST_YEAR,
	MONTH_PRESET_ID,
	QUARTER_PRESET_ID,
	YEAR_PRESET_ID,
} from "components/Shared/MultiRangeCalendar/constants"
import { CURRENT_MONTH, CURRENT_QUARTER, CURRENT_YEAR } from "helpers/temporal"
import { MetricName } from "./components/MetricsSelect/interfaces"
import { COLOR_PALETTE } from "colors"

export const ERROR_CODE_TIMEOUT = "PH-0003"
export const STATUS_CODE_TIMEOUT = "408"
export const GATEWAY_TIMEOUT_CODE = "504"
export const BENCHMARK_ENDPOINT =
	"/transactional/commercial-benchmark/breakdown"
export const BENCHMARK_TIMELINE_ENDPOINT =
	"/transactional/commercial-benchmark/timeline"
export const BENCHMARK_SUMMARY_ENDPOINT =
	"/transactional/commercial-benchmark/summary"
export const ID_INFORMATION_TABLE = "transactional-benchmark"
export const DEFAULT_SORTING = "currentSales"
export const POSITIVE_VARIATION = "positive-variation"
export const NEGATIVE_VARIATION = "negative-variation"
export const ZERO_VARIATION = ""
export const ITEMS_PER_PAGE = 10
export const FIRST_BAR_SALES = 0
export const CONFIG_MARGIN_RESPONSIVE_BAR = {
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
}
export const LEVEL_NAME_DEFAULT = "department"
export const CURRENT_PERIOD = "current"
export const PREVIOUS_PERIOD = "previous"
export const KEYS_RESPONSIVE_BAR = ["Current_Sales", "Previous_Sales"]
export const INNER_PADDING_RESPONSIVE_BAR = 2
export const PADDING_RESPONSIVE_BAR = -1
export const ALL_VALUE_FILTER = "0"
export const ALL_VALUE = "ALL"
export const PRESET = "PRESET"
export const DEFAULT_SUBTITLE_ID =
	"phronesis.transactional.application.commercial.benchmark.insight.subtitle"
export const DEPARTMENT_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.department"
export const CATEGORIES_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.categories"
export const SUB_CATEGORIES_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.sub.categories"

export const DEPARTMENT_MARKET_TITLE_MULTIPLE =
	"phronesis.transactional.application.growth-profiling.chart.market.department.multiple"
export const CATEGORIES_MARKET_TITLE_MULTIPLE =
	"phronesis.transactional.application.growth-profiling.chart.market.categories.multiple"
export const SUB_CATEGORIES_MARKET_TITLE_MULTIPLE =
	"phronesis.transactional.application.growth-profiling.chart.market.sub.categories.multiple"

export enum LabelMessages {
	UNITS_EN = "units_en",
}

export const LabelTranslation: Record<string, string> = {
	[LabelMessages.UNITS_EN]:
		"phronesis.transactional.application.commercial.benchmark.insight.subtitle.units",
}

export const BENCHMARK_TABLE_TITLE_ID =
	"phronesis.transactional.application.commercial.benchmark.table.title"

export const disclaimer = {
	id:
		"phronesis.transactional.application.commercial.benchmark.filters.date.disclaimer",
}

export const optionsLegendTable = [
	{
		code: "MONTH_PRESET",
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentMonth",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousMonth",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.month.sales.end",
	},
	{
		code: "QUARTER_PRESET",
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentQuarter",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousQuarter",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.quarter.sales.end",
	},
	{
		code: "YEAR_PRESET",
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentYear",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousYear",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.year.sales.end",
	},
	{
		code: "MOBILE_YEAR_PRESET",
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentMobile",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousMobile",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.year.sales.end",
	},
	{
		code: "CUSTOM_RANGES",
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentCustom",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousCustom",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.month.sales.end",
	},
	{
		code: CURRENT_QUARTER_VS_LAST_YEAR,
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentQuarter",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousQuarter",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.quarter.sales.end",
	},
	{
		code: MOBILE_QUARTER_VS_LAST_YEAR,
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentQuarter",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousQuarter",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.quarter.sales.end",
	},
	{
		code: MONTH_DATE_VS_LAST_YEAR,
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentMonth",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousMonth",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.month.sales.end",
	},
	{
		code: MOBILE_MONTH_VS_LAST_YEAR,
		current:
			"phronesis.transactional.application.commercial.benchmark.legend.currentMonth",
		previous:
			"phronesis.transactional.application.commercial.benchmark.legend.previousMonth",
		period:
			"phronesis.transactional.application.commercial.benchmark.subTitle.month.sales.end",
	},
]

export const subTitleDeparment = {
	id:
		"phronesis.transactional.application.commercial.benchmark.subTitle.department",
}

export const legendsWithClassAndPeriod = [
	{
		period: "previous",
	},
	{
		period: "current",
	},
]

export const benchmarkLegends = [
	{
		period: "current",
	},
	{
		period: "previous",
	},
]

export const variationValues = [
	{
		resultVariation: 1,
		operator: "+",
		classCss: POSITIVE_VARIATION,
	},
	{
		resultVariation: -1,
		operator: "",
		classCss: NEGATIVE_VARIATION,
	},
	{
		resultVariation: 0,
		operator: "",
		classCss: ZERO_VARIATION,
	},
]

export const textNoSales = {
	id: "phronesis.transactional.application.commercial.benchmark.noSales",
}

export const textTotalSalesTab =
	"phronesis.transactional.application.commercial.benchmark.tab.title"

export const textBenchmarkByChannel =
	"phronesis.transactional.application.commercial.benchmark.by.channel.tab.title"

export const textBenchmarkByBrand =
	"phronesis.transactional.application.commercial.benchmark.by.brand.tab.title"

export const textBenchmarkByFormat =
	"phronesis.transactional.application.commercial.benchmark.by.format.tab.title"

export const textBenchmarkByLocation =
	"phronesis.transactional.application.commercial.benchmark.by.location.tab.title"

export const DELAY_FILTERS_MS = 100

export enum COLUMN_NAMES {
	CHANNEL = "channels",
	BRAND = "brands",
	FORMAT = "formats",
	REGION = "region",
	COUNTY = "county",
	STORE = "store",
	ITEM = "item",
}

export enum METRICS {
	BY_LEVEL = "by_level",
	BY_CHANNEL = "by_channel",
	BY_BRAND = "by_brand",
	BY_FORMAT = "by_format",
	BY_LOCATION = "by_location",
}

export const PREVIOUS_COLOR = COLOR_PALETTE.YELLOW_600
export const CURRENT_COLOR = COLOR_PALETTE.PURPLE_500
export const TIMELINE_LEGEND_HEIGHT = 10
export const TIMELINE_LEGEND_WIDTH = 35
export const TIMELINE_COMPONENT_FEATURE_FLAG_ID =
	"transactionalBenchmarkTimeline"
export const TIMELINE_DOUBLE_AXIS_COMPONENT_FEATURE_FLAG_ID =
	"transactionalBenchmarkDoubleTimeline"
export const TIMELINE_GROWTH_COMPONENT_FEATURE_FLAG_ID =
	"transactionalBenchmarkGrowthTimeline"
export const SLICE_TIMELINE_X = "x"
export const WALMART = "WALMART"
export const SUMMARY_COMPONENT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricCards"
export const METRIC_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricSelect"
export const METRIC_SALES_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricSalesSelectFeatureFlagId"
export const METRIC_UNITS_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricUnitsSelectFeatureFlagId"
export const METRIC_TRANSACTIONS_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricTransactionsSelectFeatureFlagId"
export const METRIC_CLIENTS_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricClientsSelectFeatureFlagId"
export const METRIC_PENETRATION_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricPenetrationSelectFeatureFlagId"
export const METRIC_AVG_TICKET_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricAvgTicketSelectFeatureFlagId"
export const METRIC_AVG_SPEND_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricAvgSpendSelectFeatureFlagId"
export const METRIC_AVG_PRICE_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricAvgPriceSelectFeatureFlagId"
export const METRIC_PURCHASE_FRECUENCY_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricPurchaseFrecuencySelectFeatureFlagId"
export const METRIC_ITEMS_PER_VISIT_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricItemsPerVisitSelectFeatureFlagId"
export const METRIC_STORES_SELLING_SELECT_FEATURE_FLAG_ID =
	"transactionalBenchmarkMetricStoresSellingSelectFeatureFlagId"
export const TIMELINE_METRIC = "_timeline"
export const SUMMARY_METRIC = "_summary"
export const BREAKDOWN_METRIC = "_breakdown_"
export const SELECT_METRIC_TITLE_ID =
	"phronesis.transactional.application.commercial.benchmark.metric.select.title"
export const SELECT_PENETRATION_TITLE_ID =
	"phronesis.transactional.application.commercial.benchmark.penetration.select.title"

export const SELECT_PENETRATION_TITLE =
	"phronesis.transactional.application.commercial.benchmark.title"
export const SELECT_PENETRATION_SUBTITLE =
	"phronesis.transactional.application.commercial.benchmark.subtitle"

export const TRANSLATION_PRESETS_RANGES: { [key: string]: string } = {
	[YEAR_PRESET_ID]: CURRENT_YEAR,
	[MONTH_PRESET_ID]: CURRENT_MONTH,
	[QUARTER_PRESET_ID]: CURRENT_QUARTER,
}

export const day_format = "DD/MM/YYY"

export const BENCHMARK_PENETRATION_SUMMARY_QUERY =
	"BENCHMARK_REACH_SUMMARY_QUERY"

export const FEATURE_FLAG_BENCHMARK_V2: Record<MetricName, boolean> = {
	sales: false,
	units: false,
	transactions: false,
	clients: false,
	penetration: false,
	"purchase-frequency": true,
	"average-price-per-item": true,
	"average-spend": true,
	"average-ticket": true,
	"items-per-visit": true,
	"stores-selling": true,
}
